const Locations = ({
  departureDate,
  departureTime,
  arrivalTime,
  originName,
  destinationName,
  specificOriginName,
  specificDestinationName
}) => {
  return (
    <div className='w-full text-left'>
      <div className='text-xl font-bold text-espresso dark:text-white mb-4'>{departureDate}</div>
      <div className='flex gap-4'>
        <div className='flex flex-col justify-between items-start w-11 shrink-0 text-sm font-medium text-warm_gray dark:text-gray-400'>
          <span>{departureTime}</span>
          <span>{arrivalTime}</span>
        </div>
        <div className='flex flex-col items-center'>
          <span className='mt-1 w-3 h-3 rounded-full bg-coral shrink-0' />
          <span className='flex-1 w-0.5 my-1 bg-coral/30' />
          <span className='w-3 h-3 rounded-full bg-coral shrink-0' />
        </div>
        <div className='flex-1 flex flex-col justify-between gap-5'>
          <div>
            <div className='text-lg font-bold text-espresso dark:text-white'>{originName}</div>
            {specificOriginName && (
              <div className='text-sm text-warm_gray dark:text-gray-400 mt-0.5'>{specificOriginName}</div>
            )}
          </div>
          <div>
            <div className='text-lg font-bold text-espresso dark:text-white'>{destinationName}</div>
            {specificDestinationName && (
              <div className='text-sm text-warm_gray dark:text-gray-400 mt-0.5'>{specificDestinationName}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Locations
